<div class="d-block d-lg-none">
  <fgb-page-header [pageTitle]="'wallet.page.title'" [showQr]="false"></fgb-page-header>
</div>

<div class="container pt-4 pt-lg-0">
  <div class="d-flex">
    <div class="text-danger cursor-pointer back-button">
      <a
        class="back-btn text-primary cursor-pointer d-none d-lg-flex align-items-center justify-content-center"
        (click)="goBack()"
      >
        <span class="material-symbols-outlined ms-2 text-white"> arrow_back_ios </span>
      </a>
    </div>

    <!-- Image -->
    <div class="loyalty-details-image border-0 rounded overflow-hidden p-0">
      <img
        [ngClass]="{
          'image-opacity': currentCampaign?.campaignRedemptions_Quantity == 0,
        }"
        alt=""
        [src]="currentCampaign?.image_URL"
        class="logo"
      />
    </div>
    <div class="back-button icon-placement text-end">
      <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity == 0">
        <span class="back-button icon material-icons text-grey text-end fw-bold ms-3"> lock </span>
      </ng-container>
      <ng-container *ngIf="currentCampaign?.campaignRedemptions_Quantity > 0">
        <span class="back-button icon material-icons text-success text-end fw-bold ms-3"> check_circle </span>
      </ng-container>
    </div>
  </div>
  <!-- Name -->
  <div class="text-center font-size-14 fw-bold text-white mt-10px">{{ currentCampaign?.CampaignName }}</div>
  <!-- Expiry -->
  <div class="font-size-12 text-danger text-center text-white mt-10px">
    {{ 'offer.expiry' | translate }} {{ currentCampaign?.Campaign_ExpiryDate | UtcToLocaltimePipe: dateOption.NgbDateFormat }}
  </div>
  <!-- Description -->
  <label class="pt-2 text-white mt-20px">{{ 'offer.description' | translate }}</label>
  <div class="font-size-14 text-white">{{ currentCampaign?.PortalDescription }}</div>
</div>
